export class EdiStatus {
  constructor(status, chineseLabel, englishLabel, chineseContent, englishContent) {
    this.status = status
    this.chineseLabel = chineseLabel
    this.englishLabel = englishLabel
    this.chineseContent = chineseContent
    this.englishContent = englishContent
  }
  static ediStatuses = [
    new EdiStatus(0, '未发送', 'Create AMS Succeed', '创建AMS报文', 'create AMS'),
    new EdiStatus(1, '上传完成,处理中', 'Processing', '处理AMS报文', 'processing'),
    new EdiStatus(2, '发送成功', 'Send Succeeded', '发送AMS报文', 'send AMS'),
    new EdiStatus(3, '处理成功', 'Processing Succeeded', '处理AMS报文', 'Processing Succeeded'),
    new EdiStatus(4, '发送失败', 'Send Failed', '发送AMS报文', 'send AMS')
  ]
  // 根据状态查询
  static getObjByStatus(status) {
    return this.ediStatuses.find(p => p.status === status)
  }
}
